import React, { useContext } from 'react';
import { UserContext } from '../../../../App';

export const Stepper = ({currentStep}) => {

  const { user } = useContext(UserContext)

  return (
    <div className="w-full h-1 bg-neutral-300">
      <div className={"h-full bg-gradient-to-r from-emerald-500 to-emerald-700 transition-[] duration-500 " + (currentStep === 0 ? "w-0" : currentStep === 1 ? (typeof user !== 'undefined' && user.stripe.payouts_enabled && user.verified_phone ? "w-1/2" : "w-1/3") : "w-2/3")}></div>
    </div>
  )
}